import React from 'react';
import { useTags, useAuth } from 'api';
import { Text, Button, TagCardLarge, Loading, Header } from 'ui';
import { pink } from 'config/colors';
import "./index.css";

export default function Tags(props) {
  const auth = useAuth();
  const tags = useTags(auth && auth.user.companyId);
  
  if(!tags) {
    return <Loading/>;
  }
  
  if(tags.length === 0) {
    return (
      <div className="tags-placeholder">
        <Header>
          <Text large light style={{flex:1}}>NFC Tags</Text>
          <Button to="create" label="DESIGN AN NFC TAG" small white style={{backgroundColor:pink}}/>
        </Header>
        <div className="tags-placeholder-body">
          <Text huge block white>Design Branded NFC Tags</Text>
          <Text white block>
            Design and customize your brands NFC tag. Taptivate NFC tags can be designed with your logo, message or slogan and affixed to the inside or outside of any product or package, connecting you to your customers at the Unboxing Moment.
          </Text>
          <Text white block>
            Choose from an array of shapes, sizes, and configurations or contact us with your unique shape.
          </Text>
          <Button to="create" style={{backgroundColor:"white"}}>
            <Text color="#243746">Start Your First Tag Design</Text>
          </Button>
        </div>
      </div>
    );
  }
  
  return (
    <div className="tags">
      <Header>
        <Text large light style={{flex:1}}>NFC Tags</Text>
        <Button to="create" label="DESIGN AN NFC TAG" small white style={{backgroundColor:"#fa637d"}}/>
      </Header>
      <div className="tags-grid">
        {tags.map(props => <TagCardLarge key={props.id} {...props}/>)}
      </div>
    </div>
  );
}